/**
 * Verbose client-side debug logging.
 *
 * Every log line is prefixed with a timestamp and tag so it's easy to filter
 * in the browser DevTools console.  Disable by setting `window.__EV_DEBUG = false`
 * in the console at runtime, or by building with REACT_APP_DEBUG=0.
 */

const FORCE_OFF =
  typeof process !== "undefined" &&
  (process.env.REACT_APP_DEBUG || "").trim() === "0";

function enabled(): boolean {
  if (FORCE_OFF) return false;
  // Allow runtime toggle via console: window.__EV_DEBUG = false
  if (typeof window !== "undefined" && (window as any).__EV_DEBUG === false)
    return false;
  return true;
}

function ts(): string {
  return new Date().toISOString().slice(11, 23); // HH:mm:ss.SSS
}

const STYLES: Record<string, string> = {
  api: "color:#60a5fa;font-weight:bold",       // blue
  redux: "color:#a78bfa;font-weight:bold",      // purple
  route: "color:#34d399;font-weight:bold",      // green
  ws: "color:#fbbf24;font-weight:bold",         // yellow
  error: "color:#f87171;font-weight:bold",      // red
  info: "color:#94a3b8;font-weight:bold",       // gray
};

function log(tag: string, message: string, ...data: unknown[]) {
  if (!enabled()) return;
  const style = STYLES[tag] || STYLES.info;
  // eslint-disable-next-line no-console
  console.log(`%c[${ts()}][${tag.toUpperCase()}]%c ${message}`, style, "", ...data);
}

function warn(tag: string, message: string, ...data: unknown[]) {
  if (!enabled()) return;
  // eslint-disable-next-line no-console
  console.warn(`[${ts()}][${tag.toUpperCase()}] ${message}`, ...data);
}

function error(tag: string, message: string, ...data: unknown[]) {
  // Errors always print
  // eslint-disable-next-line no-console
  console.error(`[${ts()}][${tag.toUpperCase()}] ${message}`, ...data);
}

const debug = { log, warn, error, enabled };
export default debug;
